{
  "mar": {
    "title": "மருந்து வழங்கல் பதிவு",
    "loading": "MAR ஏற்றப்படுகிறது...",
    "emptyState": "இந்த நோயாளிக்கு செயலில் உள்ள மருந்துகள் இல்லை",
    "loadError": "மருந்துகளை ஏற்ற முடியவில்லை",
    "retry": "மீண்டும் முயல்க",
    "previousDay": "முந்தைய நாள்",
    "nextDay": "அடுத்த நாள்",
    "view24h": "24h",
    "view12h": "12h",
    "viewShift": "பணிமாற்றம்",
    "dayShiftHeader": "பகல் பணி (07:00 - 19:00)",
    "nightShiftHeader": "இரவு பணி (19:00 - 07:00)",
    "newOrder": "புதிய மருந்து ஆணை",
    "printMar": "MAR அச்சிடு",
    "prnSection": "PRN மருந்துகள்",
    "filter": {
      "timeWindow": "நேர வரம்பு",
      "category": "வகை",
      "status": "நிலை",
      "scheduledOnly": "திட்டமிட்டவை மட்டும்"
    },
    "adminStatus": {
      "scheduled": "திட்டமிடப்பட்டது",
      "dueNow": "இப்போது வழங்க வேண்டியது",
      "overdue": "காலம் கடந்தது",
      "administered": "வழங்கப்பட்டது",
      "held": "நிறுத்தப்பட்டது",
      "refused": "மறுக்கப்பட்டது",
      "missed": "தவறவிடப்பட்டது"
    },
    "columns": {
      "medication": "மருந்து",
      "drug": "மருந்து",
      "doseRoute": "அளவு / வழி",
      "schedule": "அட்டவணை",
      "scheduledTime": "திட்டமிட்ட நேரம்",
      "givenTime": "வழங்கிய நேரம்",
      "givenBy": "வழங்கியவர்",
      "status": "நிலை"
    },
    "actions": {
      "administer": "வழங்கு",
      "hold": "நிறுத்து",
      "refuse": "மறு",
      "skip": "தவிர்",
      "missed": "தவறியதாகக் குறி",
      "edit": "வழங்கலைத் திருத்து",
      "viewHistory": "வரலாற்றைக் காண்",
      "givePrn": "PRN வழங்கு"
    },
    "prn": {
      "badge": "PRN",
      "highAlertBadge": "உயர் எச்சரிக்கை",
      "indication": "குறிப்பீடு: {{indication}}",
      "lastGiven": "கடைசியாக வழங்கியது: {{time}}",
      "lastGivenBy": "கடைசியாக வழங்கியது: {{time}} ({{user}})"
    },
    "orderBadge": {
      "active": "செயலில்",
      "onHold": "நிறுத்தத்தில்",
      "discontinued": "நிறுத்தப்பட்டது"
    },
    "legend": "விளக்கம்:",
    "summary": {
      "medsGivenToday": "இன்று வழங்கிய மருந்துகள்: ",
      "ofTotal": "{{total}} இல் {{given}}",
      "overdueCount_one": "{{count}} தாமதம்",
      "overdueCount_other": "{{count}} தாமதம்",
      "nextDue": "அடுத்த வழங்கல்: ",
      "nextDueAt": "{{medName}} - {{time}}"
    },
    "tooltip": {
      "given": "({{time}} இல் வழங்கப்பட்டது)",
      "pending": "பதிவு செய்யப்படுகிறது… சேவையகம் இன்னும் உறுதிப்படுத்தவில்லை"
    },
    "doseModal": {
      "title": "மருந்து வழங்கு",
      "doseGiven": "வழங்கிய அளவு",
      "siteOfAdministration": "வழங்கல் இடம்",
      "comments": "கருத்துகள்",
      "vitalsCheck": "வழங்கல் முன் உயிர்க்குறி சரிபார்ப்பு",
      "doubleCheck": "இரு-மருத்துவர் சரிபார்ப்பு",
      "verifier": "சரிபார்ப்பவர்",
      "confirm": "வழங்கலை உறுதிசெய்"
    },
    "administerDialog": {
      "doseLabel": "அளவு",
      "routeLabel": "வழங்கல் வழி",
      "siteLabel": "வழங்கல் இடம் (பொருந்துமாயின்)",
      "site": {
        "notApplicable": "பொருந்தாது",
        "leftArm": "இடது கை",
        "rightArm": "வலது கை",
        "leftDeltoid": "இடது தோள் தசை",
        "rightDeltoid": "வலது தோள் தசை",
        "leftGluteal": "இடது இடுப்பு",
        "rightGluteal": "வலது இடுப்பு",
        "leftThigh": "இடது தொடை",
        "rightThigh": "வலது தொடை",
        "abdomen": "வயிறு"
      },
      "timeAdministered": "வழங்கிய நேரம்",
      "administeredDateAria": "வழங்கிய தேதி",
      "administeredTimeAria": "வழங்கிய நேரம்",
      "notesLabel": "கருத்துகள்",
      "notesPlaceholder": "விருப்பத் கருத்துகள்..."
    },
    "prnWarning": {
      "title": "PRN இடைவெளி எச்சரிக்கை",
      "lastDoseHoursAgo": "கடைசி அளவு {{hours}} மணி நேரத்திற்கு முன்பு வழங்கப்பட்டது.",
      "minimumInterval": "குறைந்தபட்ச இடைவெளி {{hours}} மணி நேரம்.",
      "lastAdministered": "கடைசியாக வழங்கியது: {{time}}",
      "justificationLabel": "முன்கூட்டியே வழங்குவதற்கான நியாயம்",
      "justificationRequired": "*",
      "justificationPlaceholder": "குறைந்தபட்ச இடைவெளிக்கு முன் வழங்குவதற்கான மருத்துவ நியாயத்தை உள்ளிடவும்...",
      "cancel": "ரத்து",
      "overrideContinue": "மேலெழுதி தொடரு"
    },
    "toast": {
      "administered": "மருந்து வழங்கல் பதிவாகியது",
      "administerError": "வழங்கல் பதிவு தோல்வி",
      "administerNotImplemented": "MAR வழங்கல் பதிவு இன்னும் கிடைக்கவில்லை",
      "held": "மருந்து நிறுத்தப்பட்டது",
      "refused": "நோயாளி மறுப்பு பதிவாகியது",
      "skipped": "இந்த மருந்து தவிர்க்கப்பட்டது",
      "orderNotActive": "இந்த உத்தரவு இனி செயலில் இல்லை (நிறுத்தப்பட்டது, ரத்து அல்லது முடிந்தது); மருந்து வழங்கலைப் பதிவு செய்ய முடியாது."
    },
    "holdRefuseDialog": {
      "holdTitle": "மருந்தை நிறுத்து",
      "refuseTitle": "மருந்தை மறு",
      "skipTitle": "மருந்தை தவிர்",
      "scheduledLabel": "திட்டமிடப்பட்டது: {{time}}",
      "holdReasonLabel": "நிறுத்தத்திற்கான காரணம்",
      "refusalNotesLabel": "மறுப்பு குறிப்புகள்",
      "skipReasonLabel": "தவிர்ப்பதற்கான காரணம்",
      "holdReasonPlaceholder": "நிறுத்தத்திற்கான காரணத்தை உள்ளிடவும்...",
      "refusalPlaceholder": "நோயாளி மறுப்பை ஆவணப்படுத்தவும்...",
      "skipPlaceholder": "தவிர்ப்பதற்கான காரணத்தை உள்ளிடவும்...",
      "cancel": "ரத்து",
      "confirm": "உறுதிப்படுத்து"
    },
    "contextMenu": {
      "hold": "நிறுத்து",
      "refuse": "மறு",
      "skip": "தவிர்"
    },
    "holdReason": {
      "label": "நிறுத்தத்திற்கான காரணம்",
      "options": {
        "patientNpo": "நோயாளி NPO (உண்ணா நிலை)",
        "vitalsOutOfRange": "உயிர்க்குறிகள் வரம்பிற்கு வெளியே",
        "patientRefused": "நோயாளி மறுத்தார்",
        "providerOrder": "மருத்துவரின் நிறுத்த ஆணை",
        "other": "மற்றவை"
      }
    },
    "give": {
      "title": "வழங்கு · {{medication}} {{dose}}",
      "scheduledLabel": "திட்டமிடப்பட்டது {{time}}",
      "patientLabel": "நோயாளி",
      "patientLine": "{{name}} · {{mrn}}",
      "patientLineIdOnly": "நோயாளி அடையாள எண்: {{id}}",
      "medicationLabel": "மருந்து",
      "scanPatientPlaceholder": "கைப்பட்டையை ஸ்கேன் செய்யவும்",
      "scanPatientAria": "நோயாளியின் கைப்பட்டையை ஸ்கேன் செய்யவும்",
      "scanMedicationPlaceholder": "மருந்துப் பொதியின் பார்கோடை ஸ்கேன் செய்யவும்",
      "scanMedicationAria": "மருந்துப் பொதியை ஸ்கேன் செய்யவும்",
      "patientMismatch": "இந்தக் கைப்பட்டை இந்த நோயாளியுடையது அல்ல. மருந்தை வழங்க வேண்டாம்.",
      "medicationMismatch": "இந்தப் பொதி ஆணையிடப்பட்ட மருந்து அல்ல. மருந்தை வழங்க வேண்டாம்.",
      "notScannable": "ஸ்கேன் மூலம் சரிபார்க்க இயலாது — இந்த ஆணைக்குப் பார்கோடு பதிவு செய்யப்படவில்லை",
      "__review_notScannable": "Barcode scan-verification wording — confirm this reads as \"no barcode on file\", not \"wrong drug\" — needs clinical translator review",
      "overrideReason": "ஸ்கேன் செய்யாமல் வழங்குவதற்கான காரணம்",
      "overrideReasonPlaceholder": "எ.கா. கைப்பட்டை சேதமடைந்தது; பார்கோடு இல்லாத கலவை அளவு",
      "pharmacyOverride": "மருந்தகம் இந்த உயர் எச்சரிக்கை மருந்தைச் சரிபார்க்கவில்லை",
      "__review_pharmacyOverride": "Override = proceed with a recorded reason, not cancel/ignore — needs clinical translator review",
      "pharmacyOverridePlaceholder": "இந்த அளவு மருந்தக மறுஆய்வுக்குக் காத்திருக்க இயலாதது ஏன்?",
      "timeLabel": "நேரம்",
      "detailsEdit": "திருத்து",
      "detailsDone": "முடிந்தது",
      "confirmLabel": "இவை ஆணையுடனும் நான் வைத்திருக்கும் அளவுடனும் பொருந்துகின்றன",
      "cancel": "ரத்து செய்",
      "submit": "வழங்கு",
      "witness": {
        "banner": "உயர் எச்சரிக்கை — இரண்டாம் செவிலியரின் சாட்சி சரிபார்ப்பு தேவை",
        "__review_banner": "Nurse-witness (independent second-nurse double-check) register — needs clinical translator review",
        "usernameLabel": "இரண்டாம் செவிலியரின் பயனர்பெயர்",
        "passwordLabel": "கடவுச்சொல்",
        "verify": "சரிபார்",
        "verifying": "சரிபார்க்கப்படுகிறது…",
        "verified": "இரண்டாம் செவிலியரால் சாட்சி சரிபார்க்கப்பட்டது",
        "__review_verified": "Nurse-witness (independent second-nurse double-check) register — needs clinical translator review",
        "rejected": "அனுமதிச் சான்றுகள் அடையாளம் காணப்படவில்லை.",
        "overrideLabel": "சாட்சி சரிபார்ப்பு இயலாதா? இரண்டாம் செவிலியர் சரிபார்ப்பின்றி வழங்கு — காரணம்",
        "__review_overrideLabel": "Nurse-witness (independent second-nurse double-check) register — needs clinical translator review",
        "overridePlaceholder": "இந்த அளவு தனித்த இரட்டைச் சரிபார்ப்புக்குக் காத்திருக்க இயலாதது ஏன்?"
      },
      "refusal": {
        "wrongPatient": "தவறான நோயாளி — ஸ்கேன் செய்யப்பட்ட கைப்பட்டை இந்த ஆணையுடன் பொருந்தவில்லை. மருந்தை வழங்க வேண்டாம்.",
        "wrongMedication": "தவறான மருந்து — ஸ்கேன் செய்யப்பட்ட பொதி ஆணையிடப்பட்ட மருந்துடன் பொருந்தவில்லை. மருந்தை வழங்க வேண்டாம்.",
        "scanRequired": "கைப்பட்டையையும் மருந்தையும் ஸ்கேன் செய்யவும், அல்லது ஸ்கேன் செய்யாததற்கான காரணத்தைக் குறிப்பிடவும்.",
        "pharmacyVerificationRequired": "மருந்தகம் இந்த ஆணையைச் சரிபார்க்கவில்லை. சரிபார்ப்புக்குக் காத்திருக்கவும், அல்லது காத்திருக்க இயலாததற்கான காரணத்தைப் பதிவு செய்யவும்.",
        "doubleCheckRequired": "இந்த ஆணையை இரண்டாம் செவிலியர் இரட்டைச் சரிபார்ப்பு செய்யவில்லை. சாட்சி சரிபார்ப்பைப் பெறவும், அல்லது காத்திருக்க இயலாததற்கான காரணத்தைப் பதிவு செய்யவும்.",
        "doubleCheckSelf": "உங்கள் சொந்த மருந்து வழங்கலை நீங்களே சாட்சி சரிபார்க்க இயலாது. இரண்டாம் செவிலியர் இந்த அளவைச் சரிபார்க்க வேண்டும்."
      },
      "dispense": {
        "handedOver": "{{quantity}} {{time}} இல் ஒப்படைக்கப்பட்டது",
        "label": "மருந்தகம் வழங்கல்",
        "none": "இந்த ஆணைக்கு வழங்கல் பதிவு இல்லை",
        "pending": "வழங்கல் பதிவானது, இன்னும் ஒப்படைக்கப்படவில்லை",
        "prepared": "{{quantity}} {{time}} இல் தயாரிக்கப்பட்டது",
        "unavailable": "வழங்கலைச் சரிபார்க்க முடியவில்லை — பதிவை அணுக முடியவில்லை"
      }
    }
  },
  "status": {
    "active": "செயலில்",
    "held": "நிறுத்தப்பட்டது",
    "discontinued": "நிறுத்தப்பட்டது",
    "completed": "முடிந்தது",
    "refused": "மறுக்கப்பட்டது",
    "missed": "தவறவிடப்பட்டது",
    "given": "வழங்கப்பட்டது"
  },
  "route": {
    "po": "வாய்வழி (PO)",
    "iv": "நரம்பு வழி (IV)",
    "im": "தசை வழி (IM)",
    "sc": "தோலடி (SC)",
    "in": "மூக்கு வழி (IN)",
    "pr": "மலக்குடல் வழி (PR)",
    "sl": "நாக்கடி (SL)",
    "top": "மேற்பூச்சு (TOP)",
    "neb": "நெபுலைசேஷன் (NEB)",
    "pv": "பெண்குறி வழி (PV)",
    "ng": "மூக்கு-வயிற்றுக் குழாய் (NG)",
    "ophthalmic": "கண்",
    "transdermal": "தோல்வழி"
  },
  "frequency": {
    "bid": "ஒரு நாளைக்கு இரண்டு முறை (BID)",
    "tid": "ஒரு நாளைக்கு மூன்று முறை (TID)",
    "qid": "ஒரு நாளைக்கு நான்கு முறை (QID)",
    "qd": "ஒரு நாளைக்கு ஒருமுறை (QD)",
    "qhs": "உறங்கும் நேரத்தில் (QHS)",
    "prn": "தேவைப்படும்போது (PRN)",
    "stat": "உடனடியாக (STAT)",
    "continuous": "தொடர்ச்சியாக"
  },
  "formulary": {
    "title": "மருந்துத் தொகுப்பு",
    "searchPlaceholder": "மருந்தின் பெயர், பொதுப்பெயர் அல்லது குறியீட்டால் தேடவும்...",
    "clearSearch": "தேடலை அழி",
    "category": {
      "all": "அனைத்தும்",
      "analgesic": "வலி நிவாரணி",
      "antibiotic": "நுண்ணுயிர் எதிர்ப்பி",
      "antifungal": "பூஞ்சை எதிர்ப்பி",
      "antiviral": "வைரஸ் எதிர்ப்பி",
      "cardiac": "இதயம் சார்ந்தது",
      "endocrine": "உள்சுரப்பி",
      "gi": "இரைப்பை குடல்",
      "neurological": "நரம்பியல்",
      "psychiatric": "மனநலம்",
      "respiratory": "சுவாசம்",
      "other": "மற்றவை"
    },
    "columns": {
      "medication": "மருந்து",
      "genericName": "பொதுப்பெயர்",
      "form": "வகை",
      "strength": "வலிமை",
      "route": "வழங்கல் வழி",
      "status": "நிலை",
      "schedule": "கட்டுப்பாட்டு வகை"
    },
    "highAlertBadge": "உயர் எச்சரிக்கை மருந்து",
    "highAlertTag": "உயர் எச்சரிக்கை",
    "status": {
      "preferred": "பரிந்துரைக்கப்பட்டது",
      "restricted": "வரம்பு உள்ளது",
      "nonFormulary": "தொகுப்பிற்கு வெளியே"
    },
    "loading": "மருந்துத் தொகுப்பு ஏற்றப்படுகிறது...",
    "loadError": "மருந்துத் தொகுப்பை ஏற்ற முடியவில்லை",
    "empty": "மருந்துகள் எதுவும் கிடைக்கவில்லை.",
    "pagination": {
      "showing": "மொத்தம் {{total}}-இல் {{from}}-{{to}} காட்டப்படுகின்றன",
      "page": "பக்கம் {{page}} / {{totalPages}}",
      "previous": "முந்தைய பக்கம்",
      "next": "அடுத்த பக்கம்"
    },
    "details": {
      "close": "விவரங்களை மூடு",
      "genericName": "பொதுப்பெயர்",
      "category": "வகை",
      "formStrength": "வகை / வலிமை",
      "route": "வழங்கல் வழி",
      "formularyStatus": "தொகுப்பு நிலை",
      "deaSchedule": "DEA கட்டுப்பாட்டு வகை",
      "indications": "பயன்பாட்டு நோக்கம்",
      "contraindications": "முரண்பாடுகள்",
      "interactions": "மருந்து இடையீடுகள்",
      "sideEffects": "பக்க விளைவுகள்",
      "dosageGuidelines": "அளவு வழிகாட்டுதல்கள்",
      "specialPopulations": "சிறப்புப் பிரிவினர்",
      "storage": "சேமிப்பு"
    }
  },
  "worklist": {
    "title": "Medication Worklist",
    "subtitle": "Active medications for the patients in your care",
    "summary": "{{medications}} medications across {{patients}} patients",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by patient name, MRN, or medication...",
    "openMar": "Open MAR",
    "loadError": "Failed to load the medication worklist",
    "retry": "Retry",
    "priority": {
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "empty": {
      "title": "Nothing to administer",
      "description": "No active medications for your patients."
    },
    "columns": {
      "medication": "Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "priority": "Priority"
    },
    "row": {
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "unknownPatient": "Unknown patient",
      "medCount_one": "{{count}} active medication",
      "medCount_other": "{{count}} active medications",
      "controlled": "Controlled {{schedule}}"
    }
  },
  "pharmacist": {
    "title": "மருந்தாளர் சரிபார்ப்பு வரிசை",
    "subtitle": "காத்திருக்கும் மருந்து உத்தரவுகளை மறுபரிசீலனை செய்யவும்",
    "pendingCount": "{{count}} காத்திருப்பு",
    "refresh": "புதுப்பி",
    "searchPlaceholder": "மருந்து, நோயாளி பெயர் அல்லது MRN ஆல் தேடவும்...",
    "priority": {
      "all": "அனைத்து முன்னுரிமைகள்",
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "வழக்கமான",
      "scheduled": "திட்டமிடப்பட்டது"
    },
    "loadError": "மருந்து வரிசையை ஏற்ற முடியவில்லை",
    "retry": "மீண்டும் முயற்சி",
    "empty": {
      "title": "அனைத்தும் முடிந்தது",
      "description": "சரிபார்க்க காத்திருக்கும் மருந்து உத்தரவுகள் இல்லை."
    },
    "columns": {
      "patient": "நோயாளி",
      "medication": "மருந்து",
      "doseRouteFreq": "அளவு / வழி / அலைவெண்",
      "priority": "முன்னுரிமை",
      "orderingProvider": "உத்தரவிட்ட மருத்துவர்",
      "ordered": "உத்தரவிட்ட நேரம்",
      "actions": "செயல்கள்"
    },
    "row": {
      "unknown": "தெரியவில்லை",
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "controlled": "கட்டுப்படுத்தப்பட்டது {{schedule}}",
      "providerFallback": "மருத்துவர் #{{id}}",
      "providerUnknown": "---"
    },
    "actions": {
      "verify": "சரிபார்",
      "verifyTooltip": "இந்த மருந்து உத்தரவை சரிபார்",
      "reject": "நிராகரி",
      "rejectTooltip": "நிராகரித்து நிறுத்து",
      "confirmReject": "உறுதிசெய்",
      "cancelReject": "ரத்து",
      "rejectReasonPlaceholder": "நிராகரிப்புக் காரணம்..."
    },
    "toast": {
      "verifySuccess": "மருந்து #{{id}} சரிபார்க்கப்பட்டது",
      "verifyError": "மருந்தை சரிபார்க்க முடியவில்லை",
      "rejectSuccess": "மருந்து #{{id}} நிராகரிக்கப்பட்டு நிறுத்தப்பட்டது",
      "rejectError": "மருந்தை நிராகரிக்க முடியவில்லை",
      "rejectReasonRequired": "நிராகரிப்புக் காரணத்தை வழங்கவும்",
      "notIndependent": "மருந்து எழுதியவர் தமது ஆணையைச் சரிபார்க்க முடியாது.",
      "overrideSuccess": "ஆணை {{id}} மருந்தாளர் சரிபார்ப்பின்றி செயல்படுத்தப்பட்டது",
      "overrideError": "மேலெழுதலைப் பதிவுசெய்ய முடியவில்லை",
      "overrideReasonRequired": "மேலெழுதலுக்குக் காரணக் குறியீடும் நியாயமும் தேவை"
    },
    "verifyDialog": {
      "title": "மருந்து ஆணையைச் சரிபார்க்கவும்",
      "instruction": "நீங்கள் முடித்த ஒவ்வொரு சோதனையையும் உறுதிப்படுத்தவும். நான்கும் அவசியம் — பகுதி மறுபரிசீலனை சரிபார்ப்பு அல்ல.",
      "checks": {
        "allergy": "நோயாளியின் ஒவ்வாமைக்கு எதிராக மறுபரிசீலனை செய்தேன்",
        "interaction": "மருந்து இடைவினைகளை மறுபரிசீலனை செய்தேன்",
        "duplicateTherapy": "இரட்டை சிகிச்சையை மறுபரிசீலனை செய்தேன்",
        "doseRange": "இந்த நோயாளிக்கான அளவை மறுபரிசீலனை செய்தேன்"
      },
      "cancel": "ரத்து",
      "confirm": "ஆணையைச் சரிபார்"
    },
    "override": {
      "action": "மேலெழுது",
      "confirm": "மேலெழுதலைப் பதிவுசெய்",
      "cancel": "ரத்து",
      "tooltip": "மருந்தாளர் சரிபார்ப்பு இல்லாமல் தொடரவும். காரணம் பதிவாகும்; அதிக எச்சரிக்கை மருந்தின் மருந்தகச் சோதனையை ஈடுசெய்யாது.",
      "codeLabel": "மேலெழுதல் காரணக் குறியீடு",
      "codePlaceholder": "காரணத்தைத் தேர்ந்தெடு…",
      "justificationLabel": "மேலெழுதல் நியாயம்",
      "justificationPlaceholder": "மருந்தக மறுஆய்வு இல்லாமல் ஏன் தொடர்கிறீர்கள்?",
      "code": {
        "pharmacyClosed": "மருந்தகம் மூடப்பட்டுள்ளது",
        "urgentClinicalNeed": "அவசர மருத்துவத் தேவை",
        "pharmacyUnreachable": "மருந்தகத்தைத் தொடர்பு கொள்ள முடியவில்லை"
      }
    },
    "clarify": {
      "action": "தெளிவுபடுத்து",
      "tooltip": "மருந்தகம் இந்த ஆணையை வேறுவிதமாகப் பதிந்துள்ளது. மருந்து அளிக்கும் முன் தீர்க்கவும்.",
      "heading": "மருந்தகம் வேறுவிதமாகப் பதிந்துள்ளது",
      "holding": "(ஆணையை நிறுத்துகிறது)",
      "upheld": "ஆணை அப்படியே",
      "upheldTooltip": "மூல ஆணை சரியானது; எழுதியபடி வழங்கவும்.",
      "amended": "நான் திருத்திவிட்டேன்",
      "amendedTooltip": "ஆணை மாற்றப்பட்டதைப் பதிவுசெய்.",
      "adopt": "மருந்தகப் பதிப்பை ஏற்று",
      "adoptTooltip": "கூட்டுப் பயிற்சி ஒப்பந்தம் அல்லது P&T நெறிமுறையின் கீழ் பதிந்த பதிப்பை ஏற்கவும்.",
      "close": "மூடு",
      "toast": {
        "resolved": "தெளிவுபடுத்தல் தீர்ந்தது; ஆணை சரிபார்ப்புக்குத் திரும்புகிறது",
        "error": "தெளிவுபடுத்தலைத் தீர்க்க முடியவில்லை"
      }
    }
  },
  "reconciliation": {
    "title": "மருந்து சரிசெய்தல்",
    "subtitle": "{{patient}} | {{mrn}} | வருகை #{{encounter}}",
    "complete": "சரிசெய்தலை முடி",
    "loading": "மருந்துகள் ஏற்றப்படுகின்றன...",
    "column": {
      "home": "வீட்டு மருந்துகள்",
      "inpatient": "உள்நோயாளர் மருந்துகள்",
      "discharge": "வீடு திரும்பும் மருந்துகள்"
    },
    "emptyHome": "வீட்டு மருந்துகள் எதுவும் இல்லை.",
    "emptyInpatient": "உள்நோயாளர் மருந்துகள் இல்லை.",
    "emptyDischarge": "வீடு திரும்பும் மருந்துகள் இன்னும் இல்லை. மற்ற நெடுவரிசைகளில் இருந்து தொடரவும் அல்லது மாற்றவும்.",
    "changedFromHome": "வீட்டு மருந்திலிருந்து மாற்றம்",
    "action": {
      "continue": "தொடர்",
      "modify": "மாற்று",
      "discontinue": "நிறுத்து",
      "discontinueShort": "D/C",
      "newOrder": "புதியது"
    },
    "addToDischarge": "வீடு திரும்பும் மருந்தில் சேர்",
    "remove": "அகற்று",
    "modifyForm": {
      "title": "மருந்தை மாற்று",
      "dose": "அளவு",
      "route": "வழங்கல் வழி",
      "frequency": "அலைவெண்",
      "dosePlaceholder": "உதா: 500mg",
      "routePlaceholder": "உதா: PO",
      "frequencyPlaceholder": "உதா: BID",
      "cancel": "ரத்து",
      "save": "சேமி"
    },
    "back": "திரும்பு",
    "toast": {
      "completed": "மருந்து சரிசெய்தல் முடிந்தது",
      "completeError": "சரிசெய்தலை முடிக்க முடியவில்லை",
      "atLeastOne": "முடிப்பதற்கு முன் குறைந்தது ஒரு மருந்தையாவது சரிசெய்யவும்"
    }
  },
  "components": {
    "dosingCalculator": {
      "title": "மருந்தளவு கணிப்பான்",
      "weightLabel": "நோயாளியின் எடை (kg) *",
      "heightLabel": "உயரம் (cm)",
      "gfrLabel": "GFR/CrCl (mL/min)",
      "weightPlaceholder": "எ.கா. 70",
      "heightPlaceholder": "எ.கா. 170",
      "gfrPlaceholder": "விருப்பத்தேர்வு",
      "bsaLabel": "கணக்கிடப்பட்ட BSA (Mosteller):",
      "calculate": "மருந்தளவைக் கணக்கிடு",
      "error": "மருந்தளவைக் கணக்கிட முடியவில்லை. இந்த மருந்துக்கான மருந்தளவு தரவு பின்தளத்தில் இல்லாமல் இருக்கலாம்.",
      "renalAdjustment": "சிறுநீரக சரிசெய்தல்:",
      "originalDose": "அசல் மருந்தளவு:",
      "min": "குறைந்தபட்சம்:",
      "max": "அதிகபட்சம்:",
      "recommended": "பரிந்துரைக்கப்படுவது: {{dose}} {{unit}}",
      "apply": "மருந்தளவைப் பயன்படுத்து",
      "method": {
        "weightBased": "எடை அடிப்படையில்",
        "bsaBased": "BSA அடிப்படையில்",
        "flat": "நிலையான மருந்தளவு",
        "renalAdjusted": "சிறுநீரக சரிசெய்யப்பட்ட"
      },
      "unavailable": "Dosing data unavailable for {{name}} — this order isn't linked to a medication catalog entry.",
      "__review_unavailable": "EN placeholder — needs translation"
    }
  },
  "prescribe": {
    "title": "மருந்து பரிந்துரை",
    "submit": "பரிந்துரை",
    "navButton": "பரிந்துரை",
    "noActiveEncounter": "மருந்துச்சீட்டு ஒரு செயலில் உள்ள சந்திப்புடன் இணைக்கப்பட வேண்டும். பரிந்துரைப்பதற்கு முன் இந்த நோயாளியை ஒரு சந்திப்பில் திறக்கவும் அல்லது சேர்க்கவும்.",
    "fields": {
      "medication": "மருந்து",
      "dose": "அளவு",
      "doseUnit": "அலகு",
      "route": "வழி",
      "frequency": "அடிக்கடி",
      "frequencyDescription": "அடிக்கடி விவரம்",
      "duration": "கால அளவு",
      "durationUnit": "கால அலகு",
      "totalDoses": "மொத்த அளவுகள்",
      "isPrn": "தேவைப்படும்போது (PRN)",
      "prnIndication": "PRN குறிப்பீடு",
      "administrationInstructions": "வழங்கும் வழிமுறைகள்",
      "patientInstructions": "நோயாளி வழிமுறைகள்",
      "quantityDispensed": "வழங்கிய அளவு",
      "refillsAuthorized": "அனுமதிக்கப்பட்ட மறுநிரப்பல்கள்",
      "allowSubstitution": "பொது மருந்து மாற்றத்தை அனுமதி",
      "pharmacyNotes": "மருந்தக குறிப்புகள்",
      "indication": "குறிப்பீடு",
      "clinicalIndication": "மருத்துவ குறிப்பீடு",
      "priority": "முன்னுரிமை"
    },
    "sections": {
      "drug": "மருந்து",
      "dosing": "அளவு",
      "durationPrn": "கால அளவு & தேவைப்படும்போது (PRN)",
      "instructions": "வழிமுறைகள்",
      "dispensing": "வழங்கல்",
      "clinical": "மருத்துவம்"
    },
    "doseUnitPlaceholder": "எ.கா. mg",
    "drugSearch": {
      "placeholder": "மருந்துப் பட்டியலைத் தேடு…",
      "noResults": "பொருந்தும் மருந்து இல்லை",
      "clear": "தேர்வை அழி",
      "catalogRequired": "பரிந்துரைக்க மருந்துப் பட்டியலில் இருந்து மருந்தைத் தேர்ந்தெடுக்கவும்",
      "catalogOnly": "ஒவ்வொரு பாதுகாப்புச் சரிபார்ப்பும் இயங்க, பட்டியலில் உள்ள மருந்துகளை மட்டுமே பரிந்துரைக்க முடியும்.",
      "controlledBadge": "கட்டுப்படுத்தப்பட்டது — அட்டவணை {{schedule}}",
      "controlledTag": "கட்டுப்பாடு",
      "highAlertBadge": "உயர் எச்சரிக்கை மருந்து",
      "highAlertTag": "உயர் எச்சரிக்கை",
      "contraindications": "முரண்பாடுகள்: {{text}}"
    },
    "route": {
      "oral": "வாய்வழி (PO)",
      "iv": "நரம்பு வழி (IV)",
      "subcutaneous": "தோலடி (SC)",
      "intramuscular": "தசைவழி (IM)",
      "topical": "வெளிப்புற",
      "inhalation": "உள்ளிழுப்பு",
      "rectal": "மலக்குடல் வழி (PR)",
      "ophthalmic": "கண்",
      "transdermal": "தோல்வழி"
    },
    "frequency": {
      "QD": "நாளொன்றுக்கு ஒருமுறை (QD)",
      "BID": "நாளொன்றுக்கு இருமுறை (BID)",
      "TID": "நாளொன்றுக்கு மூன்றுமுறை (TID)",
      "QID": "நாளொன்றுக்கு நான்குமுறை (QID)",
      "Q4H": "4 மணிநேரத்திற்கு ஒருமுறை (Q4H)",
      "Q6H": "6 மணிநேரத்திற்கு ஒருமுறை (Q6H)",
      "Q8H": "8 மணிநேரத்திற்கு ஒருமுறை (Q8H)",
      "Q12H": "12 மணிநேரத்திற்கு ஒருமுறை (Q12H)",
      "QHS": "படுக்கும் நேரம் (QHS)",
      "PRN": "தேவைப்படும்போது (PRN)",
      "STAT": "உடனடியாக (STAT)"
    },
    "durationUnit": {
      "days": "நாட்கள்",
      "weeks": "வாரங்கள்",
      "months": "மாதங்கள்",
      "doses": "அளவுகள்"
    },
    "priority": {
      "routine": "வழக்கமான",
      "asap": "கூடிய விரைவில்",
      "stat": "அவசர"
    },
    "validation": {
      "prnIndicationRequired": "தேவைப்படும்போது ஆணைக்கு PRN குறிப்பீடு தேவை"
    },
    "contextBar": {
      "ariaLabel": "மருந்து பரிந்துரை சூழல்",
      "allergies": {
        "label": "ஒவ்வாமை",
        "none": "அறியப்பட்ட ஒவ்வாமை இல்லை",
        "severe": "கடுமையான"
      },
      "weight": {
        "label": "எடை",
        "value": "{{weight}} kg",
        "valueWithHeight": "{{weight}} kg · {{height}} cm",
        "notRecorded": "பதிவு செய்யப்படவில்லை"
      },
      "renal": {
        "label": "சிறுநீரக செயல்பாடு",
        "value": "eGFR {{egfr}} {{unit}} ({{source}})",
        "unknown": "சிறுநீரக செயல்பாடு தெரியவில்லை",
        "source": {
          "reported": "அறிக்கையிடப்பட்டது",
          "computed": "கணக்கிடப்பட்டது",
          "unknown": "தெரியவில்லை"
        }
      },
      "pregnancy": {
        "label": "Pregnancy",
        "notRecorded": "Not recorded",
        "recordedOn": "recorded {{date}}",
        "outOfDate": "out of date",
        "lactating": "Lactating"
      }
    },
    "toast": {
      "success": "மருந்து பரிந்துரைக்கப்பட்டது",
      "error": "ஆணையை பதிவு செய்ய முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
      "recordStatusError": "Could not record the pregnancy status"
    },
    "cdsWarnings": {
      "heading": "பாதுகாப்பு அறிவுறுத்தல்களுடன் பரிந்துரைக்கப்பட்டது",
      "continue": "தொடரவும்"
    },
    "safetyReview": {
      "title": "பாதுகாப்பு மறுஆய்வு தேவை",
      "proceed": "மேலெழுதி பரிந்துரை",
      "cancel": "ரத்து",
      "reasonPrompt": "மேலெழுதும் காரணத்தைத் தேர்ந்தெடுக்கவும்…",
      "freeTextLabel": "கூடுதல் விவரம்",
      "freeTextPlaceholder": "மருத்துவப் பின்னணியைச் சேர்க்கவும் (விருப்பம்)",
      "hardBlockNote": "இந்தத் தடையை மேலெழுத முடியாது.",
      "cannotOverride": "இந்த பரிந்துரையைத் தொடர முடியாது — ஒன்று அல்லது அதற்கு மேற்பட்ட தடைகளை மேலெழுத முடியாது.",
      "blockKind": {
        "cds_contraindication": "முரண்பாடு",
        "cds_unavailable": "பாதுகாப்பு பரிசோதனை கிடைக்கவில்லை",
        "renal_contraindication": "சிறுநீரக முரண்பாடு",
        "dose_range": "பரிந்துரைக்கப்பட்ட வரம்பிற்கு வெளியே அளவு",
        "pregnancy_contraindication": "கர்ப்ப அபாயம்",
        "unknown": "கூடுதல் பாதுகாப்பு தடை"
      },
      "reasonCodes": {
        "HISTORY_REVIEWED_MANUALLY": "வரலாறு கைமுறையாக மறுஆய்வு செய்யப்பட்டது",
        "NO_KNOWN_RISK_THIS_PATIENT": "இந்த நோயாளிக்கு அறியப்பட்ட ஆபத்து இல்லை",
        "URGENT_CLINICAL_NEED": "அவசர மருத்துவத் தேவை",
        "OTHER": "மற்றவை (குறிப்பிடவும்)",
        "BENEFIT_OUTWEIGHS_RISK": "நன்மை ஆபத்தை மிஞ்சுகிறது",
        "DOSE_REDUCED_PER_PROTOCOL": "நெறிமுறைப்படி அளவு குறைக்கப்பட்டது",
        "EGFR_NOT_REPRESENTATIVE": "eGFR பிரதிநிதித்துவம் இல்லை",
        "SPECIALIST_ADVICE": "நிபுணர் ஆலோசனை",
        "PATIENT_TOLERANT": "நோயாளி இந்த அளவைத் தாங்குகிறார்",
        "SPECIALIST_PROTOCOL": "நிபுணர் நெறிமுறைப்படி",
        "TITRATING_TO_EFFECT": "விளைவுக்கேற்ப சரிசெய்தல்",
        "RANGE_NOT_APPLICABLE": "வரம்பு பொருந்தாது",
        "STATUS_CONFIRMED_NEGATIVE": "கர்ப்பம் இல்லை என உறுதிசெய்யப்பட்டது",
        "BENEFIT_OUTWEIGHS_FETAL_RISK": "நன்மை கருவின் அபாயத்தை விட அதிகம்",
        "CONTRACEPTION_CONFIRMED": "பயனுள்ள கருத்தடை உறுதிசெய்யப்பட்டது",
        "PREGNANCY_BEING_TERMINATED": "கர்ப்பம் நிறுத்தப்படுகிறது"
      },
      "recordStatus": {
        "heading": "Record the patient's pregnancy status",
        "prompt": "Answering clears this block. Overriding does not answer it.",
        "notPregnant": "Not pregnant",
        "pregnant": "Pregnant",
        "notApplicable": "Not applicable",
        "button": "Record and continue"
      }
    }
  }
}
